/** Typed event bus (mitt). Implements contracts/bus.ts. Owned by the main loop. */
import mitt from "mitt";
import type { BusEvents } from "@/contracts/bus";

export const bus = mitt<BusEvents>();

/** Subscribe and get an unsubscribe function back (for effects). */
export function on<K extends keyof BusEvents>(type: K, handler: (e: BusEvents[K]) => void): () => void {
  bus.on(type, handler);
  return () => bus.off(type, handler);
}

export const announce = (text: string, politeness: "polite" | "assertive" = "polite") => bus.emit("announce", { text, politeness });
